<template>
      <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title mr-auto p-2" >MATERIAL EVENTS : {{offer.cusip}}</h5> 
              <button type="button" class="close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>

            </div>
            <div class="modal-body">
                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <table class="table align-items-center table-flush table-hover bidtbl">
                    <thead class="thead-light psticky">
                    <tr>
                      <th scope="col" class="sort text-center">EVENT DATE</th>
                      <th scope="col" class="sort text-center">EVENT CODE</th>
                      <th scope="col" class="sort text-center">EVENT TYPE</th>
                      <th scope="col" class="sort text-center">EVENT STATUS</th>
                      <th scope="col" class="sort text-center">CORRECTION DATE</th>
                      <th scope="col" class="sort text-center">MESSAGE</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="materialEvents.length == 0 && !loading">
                        <td><p class="nodata">No data available</p>
                        </td>
                    </tr>
                    <tr v-for="data in materialEvents" :key="data.id">
                      <td>{{ data.eventDate }}</td>
                      <td>{{ data.eventCode }}</td>
                      <td class="text-wrap">{{ data.eventType }}</td>
                      <td class="text-wrap">{{ data.eventStatus }}</td>
                      <td >{{ data.correctionDate }}</td>
                      <td class="text-wrap">{{ data.messageText }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
    import authService from "@/authService";
    import config from "@/config";
    export default {
        name: 'customerEmails',
        components :{
            
        },
        props: ['offer'],
        data() {
            return {
                loading : false,
                materialEvents : [], 
                dayLimit : null     
            }
        },
        methods: {  
          getEvents(){
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                this.$http
                .get(
                config.baseUrlAutoBidder +
                    "/cusip/material-events?cusip="+this.offer.cusip+"&dayLimit="+this.dayLimit,
                    auth
                )
                .then(result => {
                    this.materialEvents = result.data.materialEvents;
                    this.loading = false;
                })
            },
            getUserSetting(){
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
                "/tradebook/setting-list?cognitoSub="+authService.getUser().cognitoSub,
                auth
            )
            .then(result => {
                result.data.forEach(element => {
                  if(element.setting == "OFFERING_FEED_MATERIAL_EVENT_CHECK_DAY_LIMIT"){
                    this.dayLimit = element.value ? element.value : null;
                  }
                });
              this.getEvents();

            })
            
    },  

        },
        mounted(){
          this.getUserSetting();
        }
    };
    </script>